import { apiFetch } from "./client";

/**
 * Submit a public customer inquiry
 * @param {{ name: string, email: string, phoneNumber?: string, subject: string, message: string }} data
 */
export function submitContactInquiry(data) {
  return apiFetch("/api/contact", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

/**
 * Retrieve paginated customer inquiries (Admin)
 * @param {{ page?: number, pageSize?: number, isRead?: boolean, search?: string }} params
 */
export function getAdminInquiries({ page = 1, pageSize = 10, isRead, search } = {}) {
  const qs = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (typeof isRead === "boolean") qs.set("isRead", String(isRead));
  if (search && search.trim()) qs.set("search", search.trim());

  return apiFetch(`/api/admin/contact?${qs.toString()}`);
}

/**
 * Retrieve single customer inquiry details (Admin)
 * @param {number} id
 */
export function getAdminInquiryById(id) {
  return apiFetch(`/api/admin/contact/${encodeURIComponent(id)}`);
}

/**
 * Update an inquiry's read status or admin notes (Admin)
 * @param {number} id
 * @param {{ isRead?: boolean, adminNotes?: string }} data
 */
export function updateAdminInquiry(id, data) {
  return apiFetch(`/api/admin/contact/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

/**
 * Delete a customer inquiry (Admin)
 * @param {number} id
 */
export function deleteAdminInquiry(id) {
  return apiFetch(`/api/admin/contact/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
